export default "__VITE_ASSET__7160bdb4__"